import { CommonModule, DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';

@Component({
  selector: 'out-login-logout',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './login-logout.component.html',
  styleUrl: './login-logout.component.scss',
})
export class LoginLogoutComponent implements OnInit {
  pageTitle = '';
  endText = '';
  headText = '';
  currentYear: number = new Date().getFullYear();
  constructor(
    private meta: Meta,
    private titleService: Title,
    private activatedRoute: ActivatedRoute,
    public auth: AuthService,
    @Inject(DOCUMENT) public document: Document
  ) {}

  login() {
    this.auth.loginWithRedirect();
  }
  ngOnInit(): void {
    this.setMetaData();
  }

  private setMetaData() {
    // Access the route data directly
    this.activatedRoute.data.subscribe((data) => {
      this.headText = data['headText'];
      this.pageTitle = data['pageTitle'];
      this.endText = data['endText'];

      // Set title and meta tags
      this.titleService.setTitle(this.pageTitle);
      this.meta.addTags([
        {
          name: 'description',
          content: this.pageTitle,
        },
        {
          name: 'og:description',
          content: this.pageTitle,
        },
        {
          name: 'keywords',
          content: this.pageTitle,
        },
        { name: 'author', content: 'Only Used Tesla' },
      ]);
    });
  }
}
